import SearchCalendar from '@ui/Search/Calendar/component'
import dataLayer from 'assets/core/js/module/dataLayer'
import type {
  DateSuggestionsPlugin,
  FlexibleDatePlugin,
  PluginsConfig,
  RangeSelectionPlugin,
  Calendar as SearchCalendarType,
} from '@ui/Search/Calendar/component'
import type { DataLayer } from 'assets/core/js/module/dataLayer'

const calendarElementId = 'search_offers_checkInDate'

export default function (): SearchCalendarType | undefined {
  const inputEl = document.querySelector<HTMLElement>(`#${calendarElementId}`)

  if (!inputEl) {
    return
  }

  const setNightsFieldValue = (calendar: SearchCalendarType, value?: number): void => {
    if (calendar.element.hasAttribute('data-night-field')) {
      const nightFieldName = calendar.element.getAttribute('data-night-field')
      const nightFieldEl = document.querySelector<HTMLInputElement>(`[name="${nightFieldName}"]`)

      if (nightFieldEl && value && nightFieldEl.value !== value.toString()) {
        nightFieldEl.value = value.toString()
      }

      if (nightFieldEl && !value) {
        nightFieldEl.value = ''
      }
    }
  }

  const submitForm = (): void => {
    const searchFormSubmitButton = document.getElementById('search_offers_search') as HTMLButtonElement

    if (!searchFormSubmitButton) {
      return
    }

    //In Calendar/Component.ts there is an event listener that will close the calendar if the user clicks outside.
    searchFormSubmitButton.click()
  }

  const calendar = SearchCalendar(document.getElementById('search-form-calendar') as HTMLElement, {
    currentLocale: document.body.getAttribute('data-locale')?.split('_'),
    callbacks: {
      onChange: [
        (calendar) => {
          calendar.element.closest('.search-form__block')?.classList.add('dca-form__field--filled')
        },
      ],
      onOpen: [
        (calendar) => {
          calendar.element.closest('.search-form__block')?.classList.add('dca-form__field--focused')
        },
      ],
      onClose: [
        (calendar) => {
          calendar.element.closest('.search-form__block')?.classList.remove('dca-form__field--focused')
        },
      ],
    },
    pluginsConfig: {
      flexibleDate: (calendar) => ({
        onValueChange: (value) => {
          if (calendar.element.hasAttribute('data-flexible-date-field')) {
            const flexibleDatedName = calendar.element.getAttribute('data-flexible-date-field')
            const flexibleDateFieldEl = document.querySelector<HTMLInputElement>(`[name="${flexibleDatedName}"]`)

            if (flexibleDateFieldEl) {
              flexibleDateFieldEl.checked = value === 1
            }
          }
        },
      }),
      rangeSelection: (calendar) => ({
        ajaxUrl: calendar.input.getAttribute('data-url-get-available-checkout-dates'),
        ajaxData: {
          productId: calendar.input.getAttribute('data-product-id') as string,
        },
        onValueChange: (nights) => {
          setNightsFieldValue(calendar, nights)
          submitForm()
        },
      }),
      dateSuggestions: (calendar) => ({
        onValueChange: (nights) => {
          setNightsFieldValue(calendar, nights)
          submitForm()
        },
        onDateSuggestionSelect: (element) => {
          let data = null
          const rawData = element.getAttribute('data-datalayer-click')
          if (rawData !== null) {
            data = JSON.parse<DataLayer>(rawData)
          }
          if (data === null) {
            return
          }

          dataLayer.pushInLayer(window.coreGtmId, data)
        },
      }),
    } as {
      flexibleDate: PluginsConfig<FlexibleDatePlugin['config']>
      rangeSelection: PluginsConfig<RangeSelectionPlugin['config']>
      dateSuggestions: PluginsConfig<DateSuggestionsPlugin['config']>
    },
  })

  return calendar
}
